export const chainNames = {
  "0x1": "the Mainnet",
  "0x4": "Rinkeby Testnet",
  "0x7a69": "Hardhat Network",
};

const config = {
  // !!! This contract address may change
  CONTRACT_ADDRESS: "0xa3FcFae48237CF81bD2ebF8F764159D9bA27F3Ad",
  TARGET_CHAIN: "0x4",
  // Set the required block confirmations here
  BLOCK_CONFIRMATIONS: 1,
};

export default config;
